<apx-chart
  [id]="chartName"
  [series]="chartOptions.series!"
  [chart]="chartOptions.chart!"
  [title]="chartOptions.title!"
  [plotOptions]="chartOptions.plotOptions!"
  [labels]="chartOptions.labels!"
  [fill]="chartOptions.fill!"
  [stroke]="chartOptions.stroke!"
  [tooltip]="chartOptions.tooltip!"
></apx-chart>
